import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { types } from "../../constants/constants";
import Landing from "../landing/Landing";
import NotFound from "../not-found/NotFound";

const ServicePage = () => {
  const { slug } = useParams();
  const [service, setService] = useState(null);
  const [otherServices, setOtherServices] = useState([]);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    fetch(`${types.API_URL}services/slug/${slug}`)
      .then((res) => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then((data) => setService(data))
      .catch(() => setNotFound(true));

    fetch(`${types.API_URL}services`)
      .then((res) => res.json())
      .then((data) => {
        const others = data.services
          .filter((s) => s.slug !== slug)
          .map((s) => ({ name: s.title, link: `/servicio/${s.slug}` }));
        setOtherServices(others);
      });
  }, [slug]);

  if (notFound) return <NotFound />;
  if (!service) return null;

  const content = {
    description: service.description,
    summary: service.obtain,
    formTitle: `Contrata nuestro servicio: ${service.title}`,
    formDescription: "Todos los servicios editoriales de Bookólicos se realizarán bajo presupuesto, previo contacto del autor con nosotros (vía email) para darnos detalles de su obra y sus necesidades."
  };

  return (
    <Landing
      service={service.title}
      content={content}
      services={otherServices}
    />
  );
};

export default ServicePage;
